/**
 * getApi Path for webchat and added slash as last character if missing
 * @param chatId
 * @param requestName
 * @param path
 * @returns string
 */
const getApiPath = (chatId: string, requestName: string, path: string): string => {
    const lastChar = path.substr(-1);
    if ('/' !== lastChar) {
        path = path + '/';
    }

    return `${path}${chatId}/${requestName}/`;
};

export default getApiPath;
